module.exports = __webpack_public_path__ + "static/media/GCE_durability-min.33d6c7f0.jpg";